// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/models/v1/model_artifact.proto (package chalk.models.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ArrowType } from "../../arrow/v1/arrow_pb";
import { file_chalk_arrow_v1_arrow } from "../../arrow/v1/arrow_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/models/v1/model_artifact.proto.
 */
export const file_chalk_models_v1_model_artifact: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_arrow_v1_arrow]);

/**
 * @generated from message chalk.models.v1.TensorDimension
 */
export type TensorDimension = Message<"chalk.models.v1.TensorDimension"> & {
  /**
   * @generated from oneof chalk.models.v1.TensorDimension.value
   */
  value: {
    /**
     * e.g. 3, 224
     *
     * @generated from field: int64 fixed = 1;
     */
    value: bigint;
    case: "fixed";
  } | {
    /**
     * e.g. "batch_size", "channels"
     *
     * @generated from field: string named = 2;
     */
    value: string;
    case: "named";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.models.v1.TensorDimension.
 * Use `create(TensorDimensionSchema)` to create a new message.
 */
export const TensorDimensionSchema: GenMessage<TensorDimension> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 0);

/**
 * @generated from message chalk.models.v1.TensorSpec
 */
export type TensorSpec = Message<"chalk.models.v1.TensorSpec"> & {
  /**
   * @generated from field: chalk.arrow.v1.ArrowType dtype = 1;
   */
  dtype?: ArrowType;

  /**
   * e.g., [batch, height, width, channels],
   *
   * @generated from field: repeated chalk.models.v1.TensorDimension shape = 2;
   */
  shape: TensorDimension[];

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message chalk.models.v1.TensorSpec.
 * Use `create(TensorSpecSchema)` to create a new message.
 */
export const TensorSpecSchema: GenMessage<TensorSpec> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 1);

/**
 * @generated from message chalk.models.v1.TabularSpec
 */
export type TabularSpec = Message<"chalk.models.v1.TabularSpec"> & {
  /**
   * @generated from field: chalk.arrow.v1.ArrowType dtype = 1;
   */
  dtype?: ArrowType;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message chalk.models.v1.TabularSpec.
 * Use `create(TabularSpecSchema)` to create a new message.
 */
export const TabularSpecSchema: GenMessage<TabularSpec> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 2);

/**
 * @generated from message chalk.models.v1.TensorSchema
 */
export type TensorSchema = Message<"chalk.models.v1.TensorSchema"> & {
  /**
   * @generated from field: repeated chalk.models.v1.TensorSpec tensors = 1;
   */
  tensors: TensorSpec[];
};

/**
 * Describes the message chalk.models.v1.TensorSchema.
 * Use `create(TensorSchemaSchema)` to create a new message.
 */
export const TensorSchemaSchema: GenMessage<TensorSchema> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 3);

/**
 * @generated from message chalk.models.v1.TabularSchema
 */
export type TabularSchema = Message<"chalk.models.v1.TabularSchema"> & {
  /**
   * @generated from field: repeated chalk.models.v1.TabularSpec columns = 1;
   */
  columns: TabularSpec[];
};

/**
 * Describes the message chalk.models.v1.TabularSchema.
 * Use `create(TabularSchemaSchema)` to create a new message.
 */
export const TabularSchemaSchema: GenMessage<TabularSchema> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 4);

/**
 * @generated from message chalk.models.v1.ModelSchema
 */
export type ModelSchema = Message<"chalk.models.v1.ModelSchema"> & {
  /**
   * @generated from oneof chalk.models.v1.ModelSchema.schema_type
   */
  schemaType: {
    /**
     * @generated from field: chalk.models.v1.TensorSchema tensor = 1;
     */
    value: TensorSchema;
    case: "tensor";
  } | {
    /**
     * @generated from field: chalk.models.v1.TabularSchema tabular = 2;
     */
    value: TabularSchema;
    case: "tabular";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.models.v1.ModelSchema.
 * Use `create(ModelSchemaSchema)` to create a new message.
 */
export const ModelSchemaSchema: GenMessage<ModelSchema> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 5);

/**
 * @generated from message chalk.models.v1.ModelSignature
 */
export type ModelSignature = Message<"chalk.models.v1.ModelSignature"> & {
  /**
   * @generated from field: chalk.models.v1.ModelSchema inputs = 1;
   */
  inputs?: ModelSchema;

  /**
   * @generated from field: chalk.models.v1.ModelSchema outputs = 2;
   */
  outputs?: ModelSchema;
};

/**
 * Describes the message chalk.models.v1.ModelSignature.
 * Use `create(ModelSignatureSchema)` to create a new message.
 */
export const ModelSignatureSchema: GenMessage<ModelSignature> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 6);

/**
 * @generated from message chalk.models.v1.ModelFile
 */
export type ModelFile = Message<"chalk.models.v1.ModelFile"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int64 size_kb = 2;
   */
  sizeKb: bigint;

  /**
   * @generated from field: bytes file_hash = 3;
   */
  fileHash: Uint8Array;

  /**
   * @generated from field: optional string mount_path = 4;
   */
  mountPath?: string;

  /**
   * @generated from field: optional uint32 mode = 5;
   */
  mode?: number;
};

/**
 * Describes the message chalk.models.v1.ModelFile.
 * Use `create(ModelFileSchema)` to create a new message.
 */
export const ModelFileSchema: GenMessage<ModelFile> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 7);

/**
 * @generated from message chalk.models.v1.ModelArtifactSpec
 */
export type ModelArtifactSpec = Message<"chalk.models.v1.ModelArtifactSpec"> & {
  /**
   * @generated from field: repeated chalk.models.v1.ModelFile model_files = 1;
   */
  modelFiles: ModelFile[];

  /**
   * @generated from field: repeated chalk.models.v1.ModelFile additional_files = 2;
   */
  additionalFiles: ModelFile[];

  /**
   * e.g. "sklearn", "xgboost", "pytorch", etc.
   *
   * @generated from field: chalk.models.v1.ModelType model_type = 3;
   */
  modelType: ModelType;

  /**
   * e.g. "pickle", "joblib", etc.
   *
   * @generated from field: chalk.models.v1.ModelEncoding model_encoding = 4;
   */
  modelEncoding: ModelEncoding;

  /**
   * e.g. classifier, regressor, etc.
   *
   * @generated from field: string model_class = 5;
   */
  modelClass: string;

  /**
   * @generated from field: chalk.models.v1.ModelSignature model_signature = 6;
   */
  modelSignature?: ModelSignature;

  /**
   * @generated from field: repeated string input_features = 7;
   */
  inputFeatures: string[];

  /**
   * @generated from field: repeated string output_features = 8;
   */
  outputFeatures: string[];

  /**
   * @generated from field: repeated string python_dependencies = 9;
   */
  pythonDependencies: string[];

  /**
   * @generated from field: optional string python_version = 10;
   */
  pythonVersion?: string;

  /**
   * Docker image for model serving
   *
   * @generated from field: optional string model_image = 11;
   */
  modelImage?: string;

  /**
   * @generated from field: optional string model_volume = 12;
   */
  modelVolume?: string;

  /**
   * @generated from field: optional bytes image_spec = 13;
   */
  imageSpec?: Uint8Array;
};

/**
 * Describes the message chalk.models.v1.ModelArtifactSpec.
 * Use `create(ModelArtifactSpecSchema)` to create a new message.
 */
export const ModelArtifactSpecSchema: GenMessage<ModelArtifactSpec> = /*@__PURE__*/
  messageDesc(file_chalk_models_v1_model_artifact, 8);

/**
 * @generated from enum chalk.models.v1.ModelType
 */
export enum ModelType {
  /**
   * @generated from enum value: MODEL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MODEL_TYPE_PYTORCH = 1;
   */
  PYTORCH = 1,

  /**
   * @generated from enum value: MODEL_TYPE_SKLEARN = 2;
   */
  SKLEARN = 2,

  /**
   * @generated from enum value: MODEL_TYPE_TENSORFLOW = 3;
   */
  TENSORFLOW = 3,

  /**
   * @generated from enum value: MODEL_TYPE_XGBOOST = 4;
   */
  XGBOOST = 4,

  /**
   * @generated from enum value: MODEL_TYPE_LIGHTGBM = 5;
   */
  LIGHTGBM = 5,

  /**
   * @generated from enum value: MODEL_TYPE_CATBOOST = 6;
   */
  CATBOOST = 6,

  /**
   * @generated from enum value: MODEL_TYPE_ONNX = 7;
   */
  ONNX = 7,
}

/**
 * Describes the enum chalk.models.v1.ModelType.
 */
export const ModelTypeSchema: GenEnum<ModelType> = /*@__PURE__*/
  enumDesc(file_chalk_models_v1_model_artifact, 0);

/**
 * @generated from enum chalk.models.v1.ModelEncoding
 */
export enum ModelEncoding {
  /**
   * @generated from enum value: MODEL_ENCODING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * .pkl, .pth
   *
   * @generated from enum value: MODEL_ENCODING_PICKLE = 1;
   */
  PICKLE = 1,

  /**
   * Joblib pickle variant
   *
   * @generated from enum value: MODEL_ENCODING_JOBLIB = 2;
   */
  JOBLIB = 2,

  /**
   * JSON format
   *
   * @generated from enum value: MODEL_ENCODING_JSON = 3;
   */
  JSON = 3,

  /**
   * Plain text format
   *
   * @generated from enum value: MODEL_ENCODING_TEXT = 4;
   */
  TEXT = 4,

  /**
   * Cross-framework HDF5
   *
   * @generated from enum value: MODEL_ENCODING_HDF5 = 5;
   */
  HDF5 = 5,

  /**
   * Protocol Buffers (SavedModel, ONNX)
   *
   * @generated from enum value: MODEL_ENCODING_PROTOBUF = 6;
   */
  PROTOBUF = 6,

  /**
   * CatBoost-specific binary
   *
   * @generated from enum value: MODEL_ENCODING_CBM = 7;
   */
  CBM = 7,

  /**
   * Cross-framework tensor format
   *
   * @generated from enum value: MODEL_ENCODING_SAFETENSORS = 8;
   */
  SAFETENSORS = 8,

  /**
   * XGBoost binary format
   *
   * @generated from enum value: MODEL_ENCODING_BST = 9;
   */
  BST = 9,
}

/**
 * Describes the enum chalk.models.v1.ModelEncoding.
 */
export const ModelEncodingSchema: GenEnum<ModelEncoding> = /*@__PURE__*/
  enumDesc(file_chalk_models_v1_model_artifact, 1);

